// Oranvelle — sticky mobile ATC bar
(function () {
  function init() {
    var atcBtn = document.querySelector('.product-form__submit');
    if (!atcBtn) return;

    var title = document.querySelector('.product__title');
    var price = document.querySelector('.price__regular .price-item--regular, .price__sale .price-item--sale');

    var bar = document.createElement('div');
    bar.id = 'orv-sticky-atc';
    bar.innerHTML =
      '<div class="orv-sticky-atc__inner">' +
        '<div class="orv-sticky-atc__info">' +
          '<span class="orv-sticky-atc__title">' + (title ? title.textContent.trim() : '') + '</span>' +
          '<span class="orv-sticky-atc__price">' + (price ? price.textContent.trim() : '') + '</span>' +
        '</div>' +
        '<button class="orv-sticky-atc__btn" type="button">Add to cart</button>' +
      '</div>';

    document.body.appendChild(bar);

    bar.querySelector('.orv-sticky-atc__btn').addEventListener('click', function () {
      atcBtn.click();
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('orv-sticky-atc--visible');
        } else {
          bar.classList.add('orv-sticky-atc--visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(atcBtn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
